import apiClient from '../lib/api/client';
import env from '../settings/env';

export interface AuthUserLoginRequest {
  code: string;
  scope: string;
  authuser: string;
  hd: string;
  prompt: string;
  return_url?: string;
}

export interface AuthUserLoginResponse {
  status: number;
  code: number;
  body: {
    token: string;
  };
}

export interface ApiError {
  error: string;
  message?: string;
}

export type AuthResponse<TData = unknown, TError = unknown> =
  | [TError, null]
  | [null, TData];

export const authService = {
  login: async (
    params: AuthUserLoginRequest
  ): Promise<AuthResponse<AuthUserLoginResponse, ApiError>> => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('state', 'puzzle');
      queryParams.append('code', params.code);
      queryParams.append('scope', params.scope);
      queryParams.append('authuser', params.authuser);
      queryParams.append('hd', params.hd);
      queryParams.append('prompt', params.prompt);

      if (params.return_url) {
        queryParams.append('return_url', params.return_url);
      }

      const response = await apiClient.get(
        `${env.HEIMDALL_URL}/auth/google_oauth2?${queryParams.toString()}`
      ) as AuthUserLoginResponse;

      return [null, response];
    } catch (error) {
      console.error('Login error:', error);
      return [
        {
          error: 'auth_error',
          message: error instanceof Error ? error.message : 'Unknown authentication error',
        },
        null,
      ];
    }
  },

  getReturnUrl: (): string => {
    return (env.PUZZLE_URL || window.location.origin || '') + 'auth/google_oauth2';
  },

  getGoogleLoginUrl: (): string => {
    const base = `${env.HEIMDALL_URL}/api/auth/google_login?project=puzzle`;
    return `${base}&return_url=${encodeURIComponent(authService.getReturnUrl())}`;
  },
};

export default authService;
